import { Link } from "react-router-dom";

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  moreLink?: string;
  moreLabel?: string;
}

export default function SectionHeading({
  title,
  subtitle,
  moreLink,
  moreLabel = "查看更多",
}: SectionHeadingProps) {
  return (
    <div className="mb-6 flex items-end justify-between gap-4">
      <div>
        <h2 className="flex items-center gap-2.5 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
          <span className="h-6 w-1.5 rounded-full bg-accent-500"></span>
          {title}
        </h2>
        {subtitle && <p className="mt-1.5 text-sm text-foreground-500">{subtitle}</p>}
      </div>
      {moreLink && (
        <Link
          to={moreLink}
          className="flex shrink-0 items-center gap-1 whitespace-nowrap text-sm font-medium text-foreground-600 transition-colors hover:text-accent-600"
        >
          {moreLabel}
          <i className="ri-arrow-right-s-line text-lg"></i>
        </Link>
      )}
    </div>
  );
}